/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EExamItemStatus } from "../types/EExamItemStatus.ts";

/**
 * @description 1 = Pending | 2 = Approved | 3 = Rejected |
 */
export const eExamItemStatusSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3)])
  .describe(
    "1 = Pending | 2 = Approved | 3 = Rejected | ",
  ) as unknown as ToZod<EExamItemStatus>;
